export default "__VITE_PUBLIC_ASSET__77864417__"